// @flow strict
import * as React from 'react';

/**
 * @ignore
 */
export const Email = (): React.Element<*> => (
  <path d="M16.502 2.99h-13c-1.381 0-2.5 1.119-2.5 2.5v0 9c0 1.381 1.119 2.5 2.5 2.5v0h13c1.381 0 2.5-1.119 2.5-2.5v0-9c0-1.381-1.119-2.5-2.5-2.5v0zM3.502 3.99h13c0 0 0.001 0 0.001 0 0.489 0 0.923 0.234 1.196 0.596l0.003 0.004-7.7 5.775-7.7-5.775c0.276-0.366 0.71-0.6 1.199-0.6 0 0 0.001 0 0.001 0h-0zM16.502 15.99h-13c-0.828 0-1.5-0.672-1.5-1.5v0-8.875l7.7 5.776c0.083 0.062 0.187 0.1 0.3 0.1s0.218-0.038 0.301-0.101l-0.001 0.001 7.7-5.775v8.875c-0 0.828-0.672 1.499-1.5 1.499v0z"></path>
);
